export default "__VITE_ASSET__acc950eb__"